<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content position-relative">
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Disclaimer Text"
                    :value="action.disclaimerText"
                    @input="updateDisclaimerText"
                    :validate="$v.action.disclaimerText"/>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Button Text"
                    :value="action.buttonText"
                    @input="updateButtonText"
                    :validate="$v.action.buttonText"/>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Return Link Text"
                    :value="action.returnLinkText"
                    @input="updateReturnLinkText"
                    :validate="$v.action.returnLinkText"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import BaseAction from '../base-action';

    export default {
        name: 'show-descriptor-disclaimer',
        extends: BaseAction,
        validations: {
            action: {
                disclaimerText: {required},
                buttonText: {required},
                returnLinkText: {required},
            },
        },
        methods: {
            updateDisclaimerText(disclaimerText) {
                this.$emit('input', this.action.cloneSelf({disclaimerText}));
            },
            updateButtonText(buttonText) {
                this.$emit('input', this.action.cloneSelf({buttonText}));
            },
            updateReturnLinkText(returnLinkText) {
                this.$emit('input', this.action.cloneSelf({returnLinkText}));
            },
            getValidationAggregate() {
                return {
                    name: 'add-nsf-fee',
                    rules: [
                        {
                            name: 'Disclaimer text is required.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.disclaimerText.required;
                            },
                        },
                        {
                            name: 'Button text is required.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.buttonText.required;
                            },
                        },
                        {
                            name: 'Return link text is required.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.returnLinkText.required;
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
